var gaya;

gaya = {
  init: function() {
      gaya.events();
      gaya.header.scroll();
      gaya.sections.init();
      gaya.utils.counter();
      gaya.utils.text_roller();
  },
  events: function() {
    $(window).on('scroll', gaya.header.scroll);
    $(".js-mobile-nav-toggle--2").on('click', gaya.header.closeDrawerMenu);
    $("[data-popup-open]").on('click', gaya.popup.open);
    $("[close-popup]").on('click', gaya.popup.close);
    $(".product-faq-item").on('click', gaya.sections.productTemplate.faqToggle);
    $(".show-all-items").on('click', gaya.collection.showAllItems);
    $(".product-selector__select").on('click', gaya.sections.productTemplate.selectToggle);
    var height = window.screen.height;

    document.documentElement.style.setProperty('--screen-height', height + "px");    
    $(window).on('resize', function() {
        var height = window.screen.height;
        
        document.documentElement.style.setProperty('--screen-height', height + "px");    
    });
  },
  header: {
      scroll: function() {
          if ($(window).scrollTop() >= 10) {
            $(".site-header").addClass("site-header--scrolled")
          } else {
              $(".site-header").removeClass("site-header--scrolled")
          }
      },
      init_topbar: function() {
        $(".announcement-bar__container").slick(
            { 
                arrows: true,
                autoplay: false,
                fade: true,
                prevArrow:'<button type="button" class="slick-prev pull-left"><svg fill="none" viewBox="0 0 21 22"><path stroke="#262626" stroke-miterlimit="10" stroke-width="2" d="M0 11h18"></path><path stroke="#262626" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2" d="M10 3l8 8-8 8"></path></svg></button>',
                nextArrow:'<button type="button" class="slick-next pull-right"><svg fill="none" viewBox="0 0 21 22"><path stroke="#262626" stroke-miterlimit="10" stroke-width="2" d="M0 11h18"></path><path stroke="#262626" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2" d="M10 3l8 8-8 8"></path></svg></button>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            arrows: true,
                            autoplay: true,
                            autoplaySpeed: 2000,
                        }
                    }
                ]
            }
          );
      },
      closeDrawerMenu: function() {
          $(".mobile-nav-wrapper.js-menu--is-open").attr("style", "transform: translateY(-100%)");
          $('.site-header__cart + [aria-controls="MobileNav"]').removeClass("mobile-nav--close");
          $('.site-header__cart + [aria-controls="MobileNav"]').addClass("mobile-nav--open");
      }
  },
  sections: {
      init: function() {
        gaya.sections.template_engagements_blogs();
        gaya.sections.ajustTitleBlogHeight();
      },
      sectionSliderImages: {
          init: function() {
            $(".slider-images").slick(
                { 
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 2500,
                    infinite: true,
                    slidesToShow: 7,
                    prevArrow:'<button type="button" class="slick-prev pull-left"><svg fill="none" viewBox="0 0 21 22"><path stroke="#262626" stroke-miterlimit="10" stroke-width="2" d="M0 11h18"></path><path stroke="#262626" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2" d="M10 3l8 8-8 8"></path></svg></button>',
                    nextArrow:'<button type="button" class="slick-next pull-right"><svg fill="none" viewBox="0 0 21 22"><path stroke="#262626" stroke-miterlimit="10" stroke-width="2" d="M0 11h18"></path><path stroke="#262626" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2" d="M10 3l8 8-8 8"></path></svg></button>',
                    responsive: [
                        {
                            breakpoint: 1240,
                            settings: {
                                slidesToShow: 6
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 5
                            }
                        },
                        {
                            breakpoint: 750,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 2,
                                variableWidth: true
                            }
                        }
                    ]
                }
              );

              $(".global-feed__container").slick(
                { 
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 2500,
                    infinite: true,
                    slidesToShow: 6,
                    responsive: [
                        {
                            breakpoint: 1240,
                            settings: {
                                slidesToShow: 5
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 4
                            }
                        },
                        {
                            breakpoint: 750,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 2,
                            }
                        }
                    ]
                }
              );
              
          }
      },
      sectionProductsList: {
          init: function() {
            if ($(window).width() < 1024) {
                if ($('.product-collection-list__slider.slick-initialized').length == 0) {
                $(".product-collection-list__slider").slick({
                    centerMode: true,
                    centerPadding: '250px',
                    speed: 300,
                    slidesToShow: 1,
                    initialSlide: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    infinite: true,
                    arrows: false,
                    responsive: [
                        {
                            breakpoint: 900,
                            settings: {
                                centerPadding: '170px',
                                arrows: false,
                                swipeToSlide: true,
                                infinite: true,
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 700,
                            settings: {
                                centerPadding: '120px',
                                slidesToShow: 2,
                                infinite: true
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                centerPadding: '70px',
                            }
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                centerPadding: '40px',
                            }
                        }
                    ]
                });
                
            }
        } else {
            if ($('.product-collection-list__slider.slick-initialized').length > 0) {
                $(".product-collection-list__slider").slick('unslick');
            }
        }
      }
    },
    sectionIconsListStyle2: {
        init: function() {
            if ($(window).width() < 751) {
                $(".Icon-list--style2 ul").slick({
                slidesToShow: 2,
                infinite: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 550,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
      }
    },
    productTemplate: {
        init: function() {
            if ($('.product-single .product-single__media-wrapper') && $('.product-single .product-single__media-wrapper').length > 1) {
                $(".product-single__media-group").slick({
                    variableWidth: true,
                    infinite: true,
                    dots: true,
                    responsive: [],
                    prevArrow: '<button type="button" class="slick-prev pull-left"><svg id="Layerprevarrow" enable-background="new 0 0 64 64" height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m54 30h-39.899l15.278-14.552c.8-.762.831-2.028.069-2.828-.761-.799-2.027-.831-2.828-.069l-17.448 16.62c-.755.756-1.172 1.76-1.172 2.829 0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552.528 0 1.056-.208 1.449-.621.762-.8.731-2.065-.069-2.827l-15.342-14.552h39.962c1.104 0 2-.896 2-2s-.896-2-2-2z"/></svg></button>',
                    nextArrow: '<button type="button" class="slick-next pull-right"><svg id="Layernextarrow" enable-background="new 0 0 64 64" height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m37.379 12.552c-.799-.761-2.066-.731-2.827.069-.762.8-.73 2.066.069 2.828l15.342 14.551h-39.963c-1.104 0-2 .896-2 2s.896 2 2 2h39.899l-15.278 14.552c-.8.762-.831 2.028-.069 2.828.393.412.92.62 1.448.62.496 0 .992-.183 1.379-.552l17.449-16.62c.756-.755 1.172-1.759 1.172-2.828s-.416-2.073-1.207-2.862z"/></svg></button">'
                })
            }
            $(".product-ingredients__items").slick({
                variableWidth: true,
                infinite: true,
                arrows: true,
                centerMode: false,
                prevArrow: '<button type="button" class="slick-prev pull-left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 14 14"><path d="M10.129.604a1.125 1.125 0 0 0-1.591 0L3.023 6.12s.049-.049-.003.004l-.082.08c-.439.44-.44 1.153 0 1.592l5.6 5.6a1.125 1.125 0 0 0 1.59-1.59L5.325 7l4.805-4.805c.44-.439.44-1.151 0-1.59z" fill="#fff"/></svg></button>',
                nextArrow: '<button type="button" class="slick-next pull-right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 14 14"><path d="M3.871.604c.44-.439 1.152-.439 1.591 0l5.515 5.515s-.049-.049.003.004l.082.08c.439.44.44 1.153 0 1.592l-5.6 5.6a1.125 1.125 0 0 1-1.59-1.59L8.675 7 3.87 2.195a1.125 1.125 0 0 1 0-1.59z" fill="#fff"/></svg></button>',
                responsive: [
                    {
                        breakpoint: 550,
                        settings: {
                            arrows: false,
                          centerMode: true
                        }
                    }
                ]
            });
          
          $(".product-review__items").slick({
                variableWidth: true,
                infinite: true,
                arrows: true,
                centerMode: false,
                prevArrow: '<button type="button" class="slick-prev pull-left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 14 14"><path d="M10.129.604a1.125 1.125 0 0 0-1.591 0L3.023 6.12s.049-.049-.003.004l-.082.08c-.439.44-.44 1.153 0 1.592l5.6 5.6a1.125 1.125 0 0 0 1.59-1.59L5.325 7l4.805-4.805c.44-.439.44-1.151 0-1.59z" fill="#fff"/></svg></button>',
                nextArrow: '<button type="button" class="slick-next pull-right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 14 14"><path d="M3.871.604c.44-.439 1.152-.439 1.591 0l5.515 5.515s-.049-.049.003.004l.082.08c.439.44.44 1.153 0 1.592l-5.6 5.6a1.125 1.125 0 0 1-1.59-1.59L8.675 7 3.87 2.195a1.125 1.125 0 0 1 0-1.59z" fill="#fff"/></svg></button>',
                responsive: [
                    {
                        breakpoint: 550,
                        settings: {
                            arrows: false,
                          centerMode: true
                        }
                    }
                ]
            });

            $(".callback-add-to-cart").on('click', function() {
                $('.product-form__cart-submit').click();
            });

  

            var max_height = 0;

            $(".product-ingredients__info").each(function() {
                var h = $(this).height();
                if (h > max_height) {
                    max_height = h;
                }
            });
            $(".product-ingredients__info").height(max_height);
          
          var max_height = 0;

          $(".product-review-item__content").each(function() {
            var h = $(this).height();
            if (h > max_height) {
              max_height = h;
            }
          });
          $(".product-review-item__content").height(max_height);


          $(window).on('scroll', function() {
              if ($('.product-single__meta') && $('.product-single__meta').length > 0) {
                var bottom = $('.product-single__meta').height() + $('.product-single__meta').offset().top;
                console.log($(window).scrollTop(), bottom);
                if ($(window).scrollTop() > bottom - 100) {
                    $(".sticky-add-to-cart").addClass("actif");
                } else {
                    $(".sticky-add-to-cart").removeClass("actif");
                }
            }
          });  
        },
        faqToggle: function() {
            $(this).toggleClass("active");
            $(this).find(".product-faq-item__response").slideToggle();
        },
        selectToggle: function() {
            if ($(this).next().attr('style') && $(this).next().attr('style').indexOf("display: block") > -1) {
                $(this).next().fadeOut();
            } else {
                $(this).next().fadeIn();
            }
            $(this).parent().toggleClass("actif");
        }
    },
    template_science_grid_image: function() {
        if ($(window).width() < 750) {
            $('[section-id="page-science-grid-image"] ul').slick({
                variableWidth: true,
                infinite: true,
                dots: true,
                arrows: false
            })
        }
    },
    template_engagements_blogs: function() {
        
    },
    ajustTitleBlogHeight: function() {
      var h = 0;
      var h2 = 0;

      if ($('.template-blog').length > 0 || $("#shopify-section-article-featured-blog").length > 0) {
        $(".article__title").each(function() {
          h = $(this).height();
          if (h > h2) {
            h2 = h; 
          }
        });


        $('.template-blog .article__title').height(h2 + 10);
        $('#shopify-section-article-featured-blog .article__title').height(h2 + 10);
      }
    },
  },
  popup: {
      open: function() {
          var popup_name = $(this).attr("data-popup-open");
          $('.custom-popup-background, [data-popup="' + popup_name + '"]').fadeIn();
      },
    close: function() {
      $(".custom-popup-background, [data-popup]").hide();
    }
  },
  collection: {
    showAllItems: function() {
      $("#shopify-section-collection-template .grid__item").toggleClass("display-all");
      $(this).toggleClass("is-show");
    }
  },
  rowcader: function() {
    var cookie_accept = false;
    if (window.localStorage.getItem('accept_cookies') != "true" ) {
     $('[data-section-type="popup-cookie"]').fadeIn(); 
    }
    $('[data-action="accept-cookies"], [href="#accept-cookies"]').on("click", function() {
      $('[data-section-type="popup-cookie"]').fadeOut(); 
      window.localStorage.setItem('accept_cookies', 'true')
    });
    if ($(window).width() > 751) {
      var h = $("#shopify-section-page-engagements-image-text .feature-row__text--additional-data, #shopify-section-page-science-image-text .feature-row__text--additional-data").height() - $(".feature-row-additional").height();
      $("#shopify-section-page-science-image-text .feature-row__image-wrapper > div, #shopify-section-page-engagements-image-text .feature-row__image-wrapper > div").attr("style", "padding-top: " + h + "px !Important");
    }
  },
  utils: {
    counter: function() {
      $("[data-counter]").each(function() {
        var x = parseFloat($(this).attr("data-counter"));
        var $counter_span = $(this).find("span");
        var y = parseFloat($(this).attr("data-counter-add"));
        
        gaya.utils.loop_counter($counter_span, x, y);
        
      });
    },
    loop_counter: function(counter, x, y) {
      setTimeout(function() {
          var new_value = Math.round((parseFloat(counter.html()) + y) * 100) / 100;
          counter.html(new_value);
          gaya.utils.loop_counter(counter, x, y);
        }, x);
    },
    text_roller: function() {
        /*var element = document.getElementById("text-roller");
        if (element && TextRoller) {
            var text_roller = new TextRoller(element);
            text_roller.start();
        }*/
    }
  }
}


$(document).ready(function() {
  gaya.init();
});
